import { convertNumberToCurrency } from '@/utility/helper/common';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@rrexpress/core';
import React from 'react';
import { IInvoiceAwb } from '@/modules/invoice/model/invoice';

const InvoiceTable: React.FC<{ data: IInvoiceAwb[], onShowReceipt: () => void }> = ({
  data,
  onShowReceipt,
}) => (
  <div className="relative">
    <div className="mb-8">
      <Table className="!table">
        <TableHead>
          <TableRow>
            <TableCell>No</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>
              <div className="text-right">Qty</div>
            </TableCell>
            <TableCell>
              <div className="text-right">Price</div>
            </TableCell>
            <TableCell>
              <div className="text-right">Diskon (%)</div>
            </TableCell>
            <TableCell>
              <div className="text-right">Diskon</div>
            </TableCell>
            <TableCell>
              <div className="text-right">Total</div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map?.((item: IInvoiceAwb, index: number) => (
            <TableRow>
              <TableCell>{index + 1}</TableCell>
              <TableCell>
                {item?.invoice_item_type === 'awb'
                  ? <div
                    className="text-blue-500 cursor-pointer"
                    onClick={() => {
                      onShowReceipt();
                    }}
                  >
                    {item?.description}
                  </div>
                  : item?.description
                }
              </TableCell>
              <TableCell>
                <div className="text-right">{item?.quantity}</div>
              </TableCell>
              <TableCell>
                <div className="text-right">{convertNumberToCurrency(item?.unit_price as number)}</div>
              </TableCell>
              <TableCell>
                <div className="text-right">{item?.discount_type === 'percent' ? convertNumberToCurrency(item?.discount_type_value as number) : '-'}</div>
              </TableCell>
              <TableCell>
                <div className="text-right">{convertNumberToCurrency(item?.discount_amount as number)}</div>
              </TableCell>
              <TableCell>
                <div className="text-right">{convertNumberToCurrency(item?.total as number)}</div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </div>
);

export default InvoiceTable;
